// services/manualTransferService.js

export const processBorrowerTransfer = async (transferData) => {
  try {
    // Input validation
    const { amount, currency, userId, projectId, milestoneId, description } = transferData;

    if (!amount || !currency || !userId || !projectId || !milestoneId) {
      throw new Error('Missing required fields');
    }

    const API_URL = process.env.REACT_APP_API_URL;
    const API_TOKEN = process.env.REACT_APP_API_TOKEN;

    if (!API_URL || !API_TOKEN) {
      throw new Error('Missing environment variables');
    }

    // Generate a transfer reference if not provided
    const transferReference =
      transferData.transferReference || `MANUAL-${Date.now()}-${Math.floor(Math.random() * 1000)}`;

    // Call your manual transfer API
    const response = await fetch(`${API_URL}/manual-transfers/to-borrower`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${API_TOKEN}`,
      },
      body: JSON.stringify({
        amount: Number(amount),
        currency,
        userId,
        projectId,
        milestoneId,
        description: description || 'Loan disbursement',
        transferReference,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to process borrower transfer');
    }

    return { data, error: null };
  } catch (error) {
    console.error('Error processing borrower transfer:', error);
    return {
      data: null,
      error: error instanceof Error ? error.message : 'An unknown error occurred',
    };
  }
};

export const processInvestorTransfer = async (transferData) => {
  try {
    const { amount, currency, userId, projectId, investmentId, borrowerId, description } = transferData;

    if (!amount || !currency || !userId || !projectId || !investmentId || !borrowerId) {
      throw new Error('Missing required fields');
    }

    const API_URL = process.env.REACT_APP_API_URL;
    const API_TOKEN = process.env.REACT_APP_API_TOKEN;

    if (!API_URL || !API_TOKEN) {
      throw new Error('Missing environment variables');
    }

    // Generate a transfer reference if not provided
    const transferReference =
      transferData.transferReference || `MANUAL-${Date.now()}-${Math.floor(Math.random() * 1000)}`;

    const response = await fetch(`${API_URL}/manual-transfers/to-investor`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${API_TOKEN}`,
      },
      body: JSON.stringify({
        amount: Number(amount),
        currency,
        userId,
        projectId,
        investmentId,
        borrowerId,
        description: description || 'Investment repayment',
        transferReference,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to process investor transfer');
    }

    return { data, error: null };
  } catch (error) {
    console.error('Error processing investor transfer:', error);
    return {
      data: null,
      error: error instanceof Error ? error.message : 'An unknown error occurred',
    };
  }
};
